import classNames from 'classnames';
import type { FC } from 'react';
import { IconFont } from '../IconFont';
import type { IIconButtonProps } from './type';

export const IconButton: FC<IIconButtonProps> = (props) => {
  // props
  const { disabled, className, iconType, active, circle, ...attrs } = props;
  return (
    <button
      {...attrs}
      type="button"
      disabled={disabled}
      className={classNames(
        'flex justify-center items-center w-6 h-6 transition enabled:hover:bg-selected enabled:active:bg-active',
        circle ? 'rounded-xl' : 'rounded',
        { 'cursor-not-allowed': disabled },
        { 'bg-active': active },
        className,
      )}
    >
      <IconFont type={iconType} />
    </button>
  );
};
